import React from 'react';

export const Up = React.memo(
  ({
    fill,
  }) => <path fillRule="evenodd" clipRule="evenodd"
              d="M14.4554 10.226C14.5269 10.1543 14.6118 10.0975 14.7052 10.0587C14.7987 10.02 14.8988 10 15 10C15.1012 10 15.2013 10.02 15.2948 10.0587C15.3882 10.0975 15.4731 10.1543 15.5446 10.226L24.7744 19.4558C24.9189 19.6003 25 19.7962 25 20.0004C25 20.2047 24.9189 20.4005 24.7744 20.545C24.63 20.6894 24.4341 20.7705 24.2299 20.7705C24.0256 20.7705 23.8297 20.6894 23.6853 20.545L15 11.8581L6.31469 20.545C6.17026 20.6894 5.97438 20.7705 5.77013 20.7705C5.56588 20.7705 5.36999 20.6894 5.22557 20.545C5.08114 20.4005 5 20.2047 5 20.0004C5 19.7962 5.08114 19.6003 5.22557 19.4558L14.4554 10.226Z"
              fill={fill}/>);
Up.displayName = 'Up';
